/* eslint-disable @typescript-eslint/no-explicit-any,no-param-reassign */
import Vue from 'vue';
import { computed, ComputedRef, ref, Ref } from '@vue/composition-api';
import { getUrlParam, asyncLoadCss } from '@tencent/magic-ui-util';
import { setSize } from '@tencent/vft-style/src/adaptation';
import store from '../store';
import { App, Page } from '../../types';
import { messageBox } from '@/ui';

const getEnvName = (config: Ref<Page>) => {
  const { env } = Vue.prototype;
  const isPad = env.isIpad || env.isApad;
  const pageType = (config.value?.pageType === 'TV' || config.value?.pageType === 'Hippy-TV') ? 'tv' : '';
  const deviceType = isPad ? 'pad' : 'phone';
  return getUrlParam('_device') || pageType || deviceType;
};

const getPageName = async (app: App): Promise<string> => {
  let pageName = getUrlParam('page');
  const testPage = (app.ABTest || []).find(item => item.name === pageName);
  if (!testPage) {
    return pageName;
  }

  const pageList = testPage.pageList || [];
  if (!pageList.length) {
    return pageName;
  }
  pageName = pageList[0].page;

  return pageName;
};

const titleHandler = (title: string) => {
  if (!title) {
    return;
  }
  const { env, tvfJsapi } = Vue.prototype;
  const { isApp, isKidApp } = env;
  window.document.title = title;
  if (isApp && !isKidApp && tvfJsapi?.env?.app !== 'browser') {
    try {
      tvfJsapi.invoke('refreshTitle', { title });
    } catch (e) {
      console.error(e);
    }
  }
};

const creatCss = async (config: Page) => {
  if (config.cssFile) {
    await asyncLoadCss(config.cssFile);
  }
  if (config.css) {
    const style = window.document.createElement('style');
    style.innerHTML = config.css;
    window.document.head.appendChild(style);
  }
};

const setShareConfig = (config: Page, page: any) => {
  const { share } = Vue.prototype;
  if (!config.shareConfig?.value && share) {
    share.disableShare();
    return;
  }
  if (!page.shareConfig) {
    page.shareConfig = {};
    if (config.shareConfig) {
      const { imgUrl, title, desc, link, promptImg, timeLineTitle } = config.shareConfig;
      imgUrl && (page.shareConfig.imgUrl = imgUrl);
      title && (page.shareConfig.title = title);
      desc && (page.shareConfig.desc = desc);
      // link && (page.shareConfig.link = link);
      page.shareConfig.link = link || window.location.href;
      timeLineTitle && (page.shareConfig.timeLineTitle = timeLineTitle);
      timeLineTitle && (page.shareConfig.singleTitle = timeLineTitle);
      promptImg && (page.shareConfig.promptImg = promptImg);
    }
    page.shareConfig.success = () => {
      Vue.prototype.$bus.$emit('magic:component:page:browser-shared', page);
      Vue.prototype.$reportExpose({
        f_resource: 'browser-shared',
        f_module: 'browser-shared', f_type: 4,
      });
    };
  }
  Vue.prototype.share?.setShareInfo(page.shareConfig);
};

const supportEnvHandler = (config: Page, page: any) => {
  if (!config.supportEnv) return;
  if (config.supportEnv === 'onlyApp' && !Vue.prototype.env.isApp) {
    const handler = (e: Event) => {
      e.stopPropagation();
      page.app.openUrl(location.href, { forceOpenApp: true });
    };
    document.addEventListener('click', handler, true);

    page.$on('hook:beforeDestroy', () => {
      document.removeEventListener('click', handler, true);
    });
  }
};

// 进页面处理，处理完后再调进页面提醒
const enterPageTask = async (pageConfig: Page, appConfig: App, page: any) => {
  if (Vue.prototype.$magicEnterPageQueue?.length) {
    for (const fn of Vue.prototype.$magicEnterPageQueue) {
      if (typeof fn === 'function') {
        await fn(page, {
          appConfig,
          pageConfig,
        });
      }
    }
  }
  Vue.prototype.$bus.$emit('magic:component:page:enter', page);
};

const usePage = (app: ComputedRef<App>) => {
  const pageName = ref(getUrlParam('page'));
  const pageReady = ref(false);

  getPageName(app.value).then((name) => {
    pageName.value = name;
    Vue.nextTick(() => pageReady.value = true);
  });

  const pageConfig = computed(() => {
    const pages: Page[] = app.value.items || [];
    const configs = pages
      .filter((page, index) => pageName.value === page.name || +pageName.value === index);
    return configs.length ? configs[0] : pages[0];
  });

  return {
    pageName,
    pageReady,

    pageConfig,

    envName: computed(() => getEnvName(pageConfig)),
    size: computed(() => setSize()),

    async pageCreated(page: any) {
      console.log('titleHandler', Vue.prototype.tvfJsapi);
      page.setShareConfig = () => {
        setShareConfig(pageConfig.value, page);
      };
      await creatCss(pageConfig.value);
      setShareConfig(pageConfig.value, page);
      titleHandler(pageConfig.value.title || '');

      const magicUiconfig = window.magicUiconfig?.length && window.magicUiconfig[0];
      if (magicUiconfig) {
        const currentTime = (new Date()).getTime();
        const beginTime = (new Date(magicUiconfig.beginTime)).getTime();
        const endTime = (new Date(magicUiconfig.endTime)).getTime();
        if (currentTime < beginTime) {
          if (page.config.beforeTime === 'redirect' && page.config.beforeTourl) {
            page.app.openUrl(page.config.beforeTourl);
          } else if (page.config.beforeTime === 'none') {

          } else {
            Vue.prototype.alert({
              title: '活动未开始',
              msg: page.config.beforeText || '活动还未开始哟☺',
              confirmText: '确认',
              confirm: () => page.app.openUrl(page.config.beforeTourl, true),
              showConfirmButton: !!page.config.beforeTourl,
            });
          }
        } else if (currentTime > endTime) {
          if (page.config.afterTime === 'redirect' && page.config.toUrl) {
            page.app.openUrl(page.config.toUrl, true);
          } else {
            messageBox.alert(
              page.config.conclusion || '活动已结束啦☺',
              '活动已结束',
              {
                confirmText: '确认',
                callback: () => {
                  page.app.openUrl(page.config.toUrl, true);
                  // 阻止浮层关闭
                  return true;
                },
                showCancelButton: false,
                // 是否关闭由 confirm 确定
                isCloseControlByConfirm: true,
                showConfirmButton: !!page.config.toUrl,
              },
            );
          }
        }
      }

      store.state.loginReady?.then((isLogin) => {
        if (!isLogin && pageConfig.value.needLogin) return page.openLogin();
        if (pageConfig.value.strictLogin) {
          store.dispatch('checkLogin', { strict: true }).then((isStrictLogin) => {
            !isStrictLogin && page.openLogin();
          });
        }
        if (isLogin) {
          enterPageTask(pageConfig.value, app.value, page);
        }
      });
    },

    pageMounted(page: any) {
      supportEnvHandler(pageConfig.value, page);

      page.app.magicPageViewReady().then(() => {
        const topElId = getUrlParam('top-el-id');
        topElId && setTimeout(() => {
          document.getElementById(topElId)?.scrollIntoView({ behavior: 'smooth' });
        }, 0);
      });
    },
  };
};

export default usePage;
